import React from "react";
import { type UseQueryOptions } from "@tanstack/react-query";
import { useResourceList } from "src/system/useResourceList/useResourceList.tsx";
import {
  DataGrid,
  type DataGridProps,
} from "src/components/DataGrid/DataGrid.tsx";
import type {
  GridFilterModel,
  GridValidRowModel,
} from "@mui/x-data-grid-premium";
import type { ValidGetListResponse } from "@exonn/base";
import type { GridSortDirection } from "@mui/x-data-grid/models/gridSortModel";
import { ResourceListContext } from "./ResourceListContext";
import type { ListActions } from "src/system/module.types.ts";

export type ResourceListProps<
  Row extends GridValidRowModel = GridValidRowModel,
> = {
  resource: string;
  filter?: GridFilterModel;
  filter2?: GridFilterModel;
  include?: string[];
  actions?: ListActions<Row>;
  expandRowOnRowClick?: boolean;
  disableStatePersistenceToUrl?: boolean;
  withoutDescendants?: boolean;
  defaultSortModel?: { [sortField: string]: GridSortDirection };
  queryOptions?: Omit<
    UseQueryOptions<
      ValidGetListResponse<Row>,
      any,
      ValidGetListResponse<Row>,
      any
    >,
    "queryFn" | "queryKey"
  >;
} & Omit<DataGridProps<any>, "columns">;

export const ResourceList = <Row extends GridValidRowModel = GridValidRowModel>(
  props: ResourceListProps<Row>,
) => {
  const { dataGridProps, context, key } = useResourceList<any>(props);

  return (
    <ResourceListContext.Provider value={context}>
      <DataGrid key={key} {...dataGridProps} />
    </ResourceListContext.Provider>
  );
};
